import React from "react";
import { HeaderSection } from "../../common/headers/HeaderSection";
import WorkshopScheduleSection from "./WorkshopBanner";
import { CourseSchedule } from "@/interfaces/CourseSchedule";

const mobileappWeek1CourseSchedule: CourseSchedule[] = [
  {
    id: 1,
    dayTitle:"Day 1",
    programTitle: "Mobile Application",
    date: "3 Jan 2024 - Rabu",
    time: "18.30 - 21.30",
  }, 
  {
    id: 2,
    dayTitle:"Day 2",
    programTitle: "Mobile Application",
    date: "4 Jan 2024 - Kamis",
    time: "18.30 - 21.30",
  },
];
const mobileappWeek2CourseSchedule: CourseSchedule[] = [
  {
    id: 3,
    dayTitle:"Day 1",
    programTitle: "Mobile Application",
    date: "10 Jan 2024 - Rabu",
    time: "18.30 - 21.30",
  },
  {
    id: 4,
    dayTitle:"Day 2",
    programTitle: "Mobile Application",
    date: "17 Jan 2024 - Rabu",
    time: "18.30 - 21.30",
  },
];
const mobileappWeek3CourseSchedule: CourseSchedule[] = [
  {
    id: 5,
    dayTitle:"Day 1",
    programTitle: "Mobile Application",
    date: "30 Jan 2024 - Selasa",
    time: "18.30 - 21.30",
  },
  {
    id: 6,
    dayTitle:"Day 2",
    programTitle: "Mobile Application",
    date: "31 Jan 2024 - Rabu",
    time: "18.30 - 21.30",
  },
];

const MobileAppWorkshopSchedule = () => {
  return (
    <div className="px-5 md:px-10">
      <HeaderSection
        title="Jadwal Program"
        subtitle="Pilih dan daftar jadwal program yang tersedia"
      />
      <WorkshopScheduleSection schedule={mobileappWeek1CourseSchedule} />
      <WorkshopScheduleSection schedule={mobileappWeek2CourseSchedule} />
      <WorkshopScheduleSection schedule={mobileappWeek3CourseSchedule} />
    </div>
  );
};

export default MobileAppWorkshopSchedule;